import { useState, useEffect } from "react";
import AuthState from "./context/auth/authState";
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import ModalView from "./components/ModalView";
import Index from "./pages/Index";
import Producto from "./pages/Producto";
import Categoria from "./pages/Categoria";
import Marca from "./pages/Marca";
import ContextStates from "./context/ContextStates";
import Login from "./pages/Login";
import Reportes from "./pages/admin/reportes";
import Search from "./pages/Search";
import IndexAdmin from "./pages/admin/Index";
import LoginAdmin from "./pages/admin/Login";
import AltaProductos from "./pages/admin/altaProductos";
import Productos from "./pages/admin/productos";
import Marcas from "./pages/admin/marcas";
import Rubros from "./pages/admin/rubros";
import Precios from "./pages/admin/precios";
import Configuracion from "./pages/admin/configuracion";
import GestionArticulos from "./pages/admin/gestionArticulos";
import Ventas from "./pages/admin/ventas";
import Clientes from "./pages/admin/clientes";
import AdminUsuarios from "./pages/admin/adminUsuarios";
import Jornadas from "./pages/jornadas";
import Envases from "./pages/admin/envases";
import JornadasAdmin from "./pages/admin/jornadas";
import Promociones from "./pages/admin/promociones";
import Proveedores from "./pages/admin/proveedores";
import Compras from "./pages/admin/compras";
import Presupuestos from "./pages/admin/presupuestos";

import Pedidos from "./pages/Pedidos";
import Pedido from "./pages/Pedido";
import Resumen from "./pages/Resumen";
import NuevoPedido from "./pages/NuevoPedido";
import Zonas from "./pages/Zonas";
import Repartos from "./pages/repartos";

function App() {
	const [nombre, setNombre] = useState("");
	const [itemSidebar, setItemSidebar] = useState(0);
	const [productos, setProductos] = useState([]);
	const [combos, setCombos] = useState([]);
	const [roles, setRoles] = useState([]);
	const [productoSelected, setProductoSelected] = useState({});
	const [productoSearch, setProductoSearch] = useState('');
	const [filProductos, setFilProductos] = useState([]);
	const [marcas, setMarcas] = useState([]);
	const [marcaSelected, setMarcaSelected] = useState({});
	const [marcaSearch, setMarcaSearch] = useState('');
	const [rubros, setRubros] = useState([]);
	const [rubroSelected, setRubroSelected] = useState({});
	const [rubroSearch, setRubroSearch] = useState('');
	const [venta, setVenta] = useState([]);
	const [ventaSelected, setVentaSelected] = useState({});
	const [viewOpen, setViewOpen] = useState(false);
	const [formView, setFormView] = useState(0);
	const [idUsuario, setIdUsuario] = useState(0);
	const [mail, setMail] = useState('');
	const [medioPago, setMedioPago] = useState(0);
	const [file, setFile] = useState([]);
	const [imagenSubida, setImagenSubida] = useState(0);
	const [modify, setModify] = useState(0);
	const [viewAdminOpen, setViewAdminOpen] = useState(0);
	const [formAdminView, setFormAdminView] = useState(false);
	const [valMarca, setValMarca] = useState(0);
	const [valRubro, setValRubro] = useState(0);
	const [viewSearch, setViewSearch] = useState(false);
	const [formPrev, setFormPrev] = useState(0);
	const [usuario, setUsuario] = useState(0)
	const [usuarios, setUsuarios] = useState([])
	const [buscarUsuario, setBuscarUsuario] = useState("")
	const [usuarioSelected, setUsuarioSelected] = useState({})
	const [clientes, setClientes] = useState([])
	const [buscarCliente, setBuscarCliente] = useState("")
	const [clienteSelected, setClienteSelected] = useState({})
	const [puntoVenta, setPuntoVenta] = useState(0)
	const [puntos, setPuntos] = useState([])
	const [puntoSelected, setPuntoSelected] = useState({})
	const [idJornada, setIdJornada] = useState(0)
	const [estadoJornada, setEstadoJornada] = useState(0)
	const [precio, setPrecio] = useState(false)
	const [prestamoSelected, setPrestamoSelected] = useState({})
	const [promoSelected, setPromoSelected] = useState({})
	const [proveedores, setProveedores] = useState([])
	const [proveedorSelected, setProveedorSelected] = useState({})
	const [buscarProveedor, setBuscarProveedor] = useState("")
	const [detalleCompra, setDetalleCompra] = useState([])
	const [proveedor, setProveedor] = useState(0)
	const [rubro, setRubro] = useState(0)
	const [compraSelected, setCompraSelected] = useState({})
	const [lineaCompra, setLineaCompra] = useState({})
	const [comboSelected, setComboSelected] = useState({})
	const [codigo, setCodigo] = useState('')
	const [jornadaSelected, setJornadaSelected] = useState({})
	const [searchTerm, setSearchTerm] = useState('');
	const [repartoSelected, setRepartoSelected] = useState({})
	const [tipoPrecio, setTipoPrecio] = useState(1)
	const [detalleJornada, setDetalleJornada] = useState(false)
	const [tipoCompra, setTipoCompra] = useState(2)
	const [pedidoSelected, setPedidoSelected] = useState({})
	const [fechaInicio, setFechaInicio] = useState('')
	const [fechaFin, setFechaFin] = useState('')
	const [productosSeleccionados, setProductosSeleccionados] = useState([])

	const [zonas, setZonas] = useState([])
	const [zona, setZona] = useState(0)
	const [pedidos, setPedidos] = useState([])
	const [tipoPedido, setTipoPedido] = useState(0)

	const [sysSuspended, setSysSuspended] = useState(false);
	const [sysChecking, setSysChecking] = useState(true);
	const [deudaWarning, setDeudaWarning] = useState(false);
	const [deudaDetails, setDeudaDetails] = useState(null);

	useEffect(() => {
		// ID 3 es PVSatya
		fetch('https://mirx.com.ar/mirx/api/check_status.php?cliente_id=1')
			.then(res => res.json())
			.then(data => {
				if (data.suspended) {
					setSysSuspended(true);
				} else if (data.meses_adeudados === 1) {
					setDeudaWarning(true);
				}
				setDeudaDetails(data);
			})
			.catch(err => console.error("Error validando estado del sistema:", err))
			.finally(() => {
				setSysChecking(false);
			});
	}, []);

	const handleIrPortalPagos = () => {
		const returnUrl = encodeURIComponent(window.location.origin);
		window.location.href = `https://mirx.com.ar/pagos?cliente_id=1&return_url=${returnUrl}`;
	};

	if (sysChecking) {
		return (
			<div style={{ height: '100vh', width: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f1f5f9', fontFamily: 'sans-serif' }}>
				<h1 style={{ color: '#64748b' }}>Verificando sistema...</h1>
			</div>
		);
	}

	if (sysSuspended) {
		return (
			<div style={{ height: '100vh', width: '100vw', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f87171', color: 'white', fontFamily: 'sans-serif', padding: '20px', textAlign: 'center' }}>
				<svg style={{ width: '80px', height: '80px', marginBottom: '20px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
				<h1 style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '10px' }}>Servicio Suspendido</h1>
				<p style={{ fontSize: '1.25rem', maxWidth: '600px', marginBottom: '15px' }}>El sistema ha sido bloqueado por falta de pago ({deudaDetails?.meses_adeudados} o más meses adeudados).</p>
				{deudaDetails && deudaDetails.monto_total > 0 && (
					<div style={{ backgroundColor: '#b91c1c', padding: '20px', borderRadius: '8px', marginBottom: '25px', width: '100%', maxWidth: '400px' }}>
						<p style={{ margin: '0 0 5px 0', fontSize: '1.1rem' }}>Monto total a regularizar:</p>
						<p style={{ margin: 0, fontSize: '2.5rem', fontWeight: 'bold' }}>${deudaDetails.monto_total.toLocaleString('es-AR')}</p>
						{deudaDetails.fecha_vencimiento && (
							<p style={{ margin: '10px 0 0 0', fontSize: '0.95rem', color: '#fca5a5' }}>
								Vencimiento más antiguo: {new Date(deudaDetails.fecha_vencimiento + 'T00:00:00').toLocaleDateString('es-AR')}
							</p>
						)}
					</div>
				)}
				<button
					onClick={handleIrPortalPagos}
					style={{ backgroundColor: '#4f46e5', color: 'white', border: 'none', padding: '15px 30px', fontSize: '1.2rem', fontWeight: 'bold', borderRadius: '8px', cursor: 'pointer', transition: 'background-color 0.2s', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', marginBottom: '20px' }}
				>
					Ir al Portal de Pagos
				</button>
			</div>
		);
	}
	return (

		<AuthState>
			<ContextStates.Provider
				value={{
					nombre, setNombre,
					itemSidebar, setItemSidebar,
					productos, setProductos,
					combos, setCombos,
					roles, setRoles,
					productoSelected, setProductoSelected,
					productoSearch, setProductoSearch,
					filProductos, setFilProductos,
					marcas, setMarcas,
					marcaSelected, setMarcaSelected,
					marcaSearch, setMarcaSearch,
					rubros, setRubros,
					rubroSelected, setRubroSelected,
					rubroSearch, setRubroSearch,
					venta, setVenta,
					ventaSelected, setVentaSelected,
					viewOpen, setViewOpen,
					formView, setFormView,
					idUsuario, setIdUsuario,
					mail, setMail,
					medioPago, setMedioPago,
					file, setFile,
					imagenSubida, setImagenSubida,
					modify, setModify,
					viewAdminOpen, setViewAdminOpen,
					formAdminView, setFormAdminView,
					valMarca, setValMarca,
					valRubro, setValRubro,
					viewSearch, setViewSearch,
					formPrev, setFormPrev,
					usuario, setUsuario,
					usuarios, setUsuarios,
					buscarUsuario, setBuscarUsuario,
					usuarioSelected, setUsuarioSelected,
					clientes, setClientes,
					buscarCliente, setBuscarCliente,
					clienteSelected, setClienteSelected,
					puntoVenta, setPuntoVenta,
					puntos, setPuntos,
					puntoSelected, setPuntoSelected,
					idJornada, setIdJornada,
					estadoJornada, setEstadoJornada,
					precio, setPrecio,
					prestamoSelected, setPrestamoSelected,
					promoSelected, setPromoSelected,
					proveedores, setProveedores,
					proveedorSelected, setProveedorSelected,
					buscarProveedor, setBuscarProveedor,
					detalleCompra, setDetalleCompra,
					proveedor, setProveedor,
					rubro, setRubro,
					compraSelected, setCompraSelected,
					lineaCompra, setLineaCompra,
					comboSelected, setComboSelected,
					codigo, setCodigo,
					jornadaSelected, setJornadaSelected,
					searchTerm, setSearchTerm,
					repartoSelected, setRepartoSelected,
					tipoPrecio, setTipoPrecio,
					detalleJornada, setDetalleJornada,
					tipoCompra, setTipoCompra,
					pedidoSelected, setPedidoSelected,
					fechaInicio, setFechaInicio,
					fechaFin, setFechaFin,
					productosSeleccionados, setProductosSeleccionados,
					zonas, setZonas,
					zona, setZona,
					pedidos, setPedidos,
					tipoPedido, setTipoPedido
				}}
			>
				<BrowserRouter>
					{deudaWarning && (
						<div style={{ position: 'fixed', bottom: '20px', right: '20px', backgroundColor: '#fffbeb', borderLeft: '4px solid #f59e0b', color: '#b45309', padding: '16px', borderRadius: '4px', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)', zIndex: 9999, maxWidth: '400px' }}>
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
								<p style={{ fontWeight: 'bold', margin: '0 0 8px 0', display: 'flex', alignItems: 'center' }}>
									<span style={{ fontSize: '1.2rem', marginRight: '8px' }}>⚠️</span> Aviso de Deuda
								</p>
								<button onClick={() => setDeudaWarning(false)} style={{ background: 'transparent', border: 'none', color: '#b45309', cursor: 'pointer', fontWeight: 'bold' }}>✕</button>
							</div>
							<p style={{ margin: '0 0 12px 0', fontSize: '0.9rem', lineHeight: '1.4' }}>Su cuenta registra 1 mes impago. Al llegar a los 2 meses el servicio se suspenderá automáticamente.</p>

							{deudaDetails && deudaDetails.fecha_vencimiento && (
								<p style={{ margin: '0 0 12px 0', fontSize: '0.9rem', color: '#92400e', display: 'flex', alignItems: 'center' }}>
									<span style={{ marginRight: '6px' }}>📅</span> Vencimiento: <strong>{new Date(deudaDetails.fecha_vencimiento + 'T00:00:00').toLocaleDateString('es-AR')}</strong>
								</p>
							)}

							{deudaDetails && deudaDetails.monto_total > 0 && (
								<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderTop: '1px solid #fde68a', paddingTop: '12px', marginTop: '4px' }}>
									<span style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Total: ${deudaDetails.monto_total.toLocaleString('es-AR')}</span>
									<button
										onClick={handleIrPortalPagos}
										style={{ backgroundColor: '#4f46e5', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.9rem' }}
									>
										Pagar Ahora
									</button>
								</div>
							)}
						</div>
					)}
					<Routes>
						<Route path='/producto/:id' element={<Producto />} />
						<Route path='/categoria/:id' element={<Categoria />} />
						<Route path='/marca/:id' element={<Marca />} />
						<Route path='/' element={<Index />} />
						<Route path='/login' element={<Login />} />
						<Route path='/search' element={<Search />} />
						<Route path='/pedidos' element={<Pedidos />} />
						<Route path='/pedido' element={<Pedido />} />
						<Route path='/zonas' element={<Zonas />} />
						<Route path='/nuevopedido' element={<NuevoPedido />} />
						<Route path='/resumen' element={<Resumen />} />
						<Route path='/admin/' element={<IndexAdmin />} />
						<Route path='/admin/login' element={<LoginAdmin />} />
						<Route path='/admin/altaproductos' element={<AltaProductos />} />
						<Route path='/admin/reportes' element={<Reportes />} />
						<Route path='/admin/productos' element={<Productos />} />
						<Route path='/admin/marcas' element={<Marcas />} />
						<Route path='/admin/rubros' element={<Rubros />} />
						<Route path='/admin/precios' element={<Precios />} />
						<Route path='/admin/configuracion' element={<Configuracion />} />
						<Route path='/admin/gestionarticulos' element={<GestionArticulos />} />
						<Route path='/admin/ventas' element={<Ventas />} />
						<Route path='/admin/clientes' element={<Clientes />} />
						<Route path='/admin/envases' element={<Envases />} />
						<Route path='/jornadas' element={<Jornadas />} />
						<Route path='/admin/adminusuarios' element={<AdminUsuarios />} />
						<Route path='/admin/jornadas' element={<JornadasAdmin />} />
						<Route path='/admin/promociones' element={<Promociones />} />
						<Route path='/admin/proveedores' element={<Proveedores />} />
						<Route path='/admin/compras' element={<Compras />} />
						<Route path='/admin/presupuestos' element={<Presupuestos />} />
						<Route path='/repartos' element={<Repartos />} />
					</Routes>
					<ModalView />
				</BrowserRouter>

			</ContextStates.Provider>
		</AuthState>

	);
}

export default App;

